export default __webpack_public_path__ + "static/player_user-b3fdade0e58e3261276c777405893a93.svg";